'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive which adds bootstrap class 'pull-right' if not IE8
 */
    .directive('pullRightUnlessIe8', function () {

        function isMie8() {
            if (navigator.appName != 'Microsoft Internet Explorer')
                return false;

            var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(navigator.userAgent) != null)
                return (parseFloat(RegExp.$1) < 9);

            return true;
        }

        return {
            restrict: 'C',
            link: function (scope, element, attrs) {

                if (!isMie8())
                    angular.element(element).addClass('pull-right');
            }
        }
    });